import { cn } from "../utils";

function GradientBorder({
  isActive = true,
  className,
}: {
  isActive?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute -inset-0.5 -z-10 rounded-md bg-linear-to-br from-primary-400 to-secondary-400 transition-opacity",
        isActive ? "opacity-100" : "opacity-0",
        className,
      )}
    />
  );
}

export default GradientBorder;
